<template>
    <div @click="preview = !preview">
        <img :class="[$style.img,$style[className]]" :src="src"/>
        <div v-show="preview" :class="$style.bg">
            <img :src="src"/>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'previewPicture',
        props: {
            src: String,
            className: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                preview: false
            }
        }
    }
</script>
<style lang="scss" module>
    .img {
        display: block;
        width: 80px;
        height: 80px;
        object-fit: contain;
        cursor: zoom-in;
        &-head {
            margin: 0 auto 10px;
            border-radius: 50%;
            object-fit: cover;
        }
    }

    .bg {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
        background-color: rgba(#000, .5);
        cursor: zoom-out;
        img {
            position: absolute;
            top: 50%;
            left: 50%;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transform: translate(-50%, -50%);
        }
    }
</style>